import React, { Component } from 'react';
import styled from 'styled-components';

import { Phrase } from '../../components/molecues';

import { Button } from '../../../common/components/atoms';

class ChunkPanel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sortMode: 0,
            sortTarget: "",
            chunk: [],
        }
    }

    set(chunk) {
        this.setState({ chunk: chunk });
    }
    get() {
        return this.state.chunk;
    }
    push(chunk) {
        let chunks = this.state.chunk;
        chunk.push(chunk);
        this.setState({ chunk: chunks });
    }

    onClickChunkEdit(e, index) {
        this.props.onClickChunkEdit(e, index);
    }
    onClickChunkDelete(e, index) {
        this.props.onClickChunkDelete(e, index);
    }

    getChunkList() {
        let chunk = [];
        chunk.push(
            <PanelWrap key={"panelblank"}>
                <div style={{ height: "5px" }}></div>
                <PileIcon onClick={e => this.onClickSortPile(e, 1)}
                    Mode={this.state.sortMode === 2}>
                    <i className="fas fa-angle-double-right" />
                </PileIcon>
            </PanelWrap>
        )

        for (let key in this.state.chunk) {
            if (!this.state.chunk[key].deleteFlg) {
                const props = {
                    phrase: this.state.chunk[key],
                    active: (this.state.sortTarget === key),
                    onClickEdit: (e) => this.onClickChunkEdit(e, this.state.chunk[key]),
                    onClickDelete: (e) => this.onClickChunkDelete(e, this.state.chunk[key]),
                }
                chunk.push(
                    <PanelWrap key={"panel" + key}
                        onClick={e => this.onClickSortTarget(e, key)}
                        onMouseDown={e => this.onMouseDownSortTarget(e, key)}
                        onMouseUp={e => this.onMouseUpSortTarget(e, key)}>
                        <Phrase key={key} {...props}></Phrase>
                        <PileIcon onClick={e => this.onClickSortPile(e, Number(key) + 2)}
                            Mode={this.state.sortMode === 2}>
                            <i className="fas fa-angle-double-right" />
                        </PileIcon>
                    </PanelWrap>
                )
            }
        }

        return chunk;
    }

    onMouseDownSortTarget(e, id) {
        let count = 10;
        this.intervalId = setInterval(() => {
            count--;
            if (count === 0) {
                this.setState({
                    sortMode: 2,
                    sortTarget: id,
                });
            }
        }, 100);
    }

    onMouseUpSortTarget(e, id) {
        clearInterval(this.intervalId);
    }

    onClickSort = (e) => {
        if (Object.keys(this.state.chunk).length === 0) return;

        let sortMode = this.state.sortMode;
        let sortTarget;
        if (sortMode === 0) {
            sortMode = 1;
            sortTarget = "";
        } else {
            sortMode = 0;
            sortTarget = "";
        }
        this.setState({
            sortMode: sortMode,
            sortTarget: sortTarget,
        });
    }
    onClickSortTarget(e, id) {
        if (this.state.sortMode === 1) {
            this.setState({
                sortMode: 2,
                sortTarget: id,
            });
        }
    }

    getSortedList(list) {
        list.sort((a, b) => {
            if (a.order < b.order) return -1;
            if (a.order > b.order) return 1;
            return 0;
        });
        let order = 0;
        for (let key in list) {
            list[key].order = order;
            order++;
        }
        return list;
    }

    onSuccess = () => {

    }
    onFailure = () => {

    }

    onClickSortPile(e, id) {
        let sortMode = this.state.sortMode;
        let sortTarget = this.state.sortTarget;
        if (sortMode === 2) {
            let temp = this.state.chunk;
            for (let key in temp) {
                if ((Number(key)+1) >= id) {
                    temp[key].order = (Number(key)+1) + 1;
                }
            }
            temp[sortTarget].order = id;
            this.setState({
                chunk: this.getSortedList(temp),
            });

            this.setState({
                sortMode: 0,
                sortTarget: "",
            });
            for (let key in temp) {
                this.props.dispatch({
                    type: "ChangeOrder_Saga",
                    id: temp[key].id,
                    order: temp[key].order,
                    mode: 2,
                    index: key,
                    onSuccess: this.onSuccess,
                    onFailure: this.onFailure,
                });
            }
        }
    }

    render() {
        return (
            <Items Height={this.props.itemHeight + "px"}>
                <Title>
                    チャンク
                <Icon onClick={this.onClickSort} Mode={this.state.sortMode}>
                        <i className="fas fa-list" />
                    </Icon>
                </Title>
                <Dummy Height={"23px"} />
                <Scroll Height={this.props.scrollHeight + "px"}>
                    <Panels>
                        {this.getChunkList()}
                    </Panels>
                </Scroll>
                <Button
                    Color="#0077FF"
                    Width="150px"
                    onClick={this.props.onCilckAddChunk}
                    marginBottom="5px"
                    text="チャンクを追加"
                />
                <Button
                    Color="#0077FF"
                    Width="80px"
                    onClick={this.props.onCilckAddAllChunk}
                    text="一括登録"
                />
            </Items>
        );
    }
}

export { ChunkPanel };

const Items = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    width: 320px;
    height: ${props => (props.Height)};

`;
const Title = styled.div`
    color: #888;
    font-weight: bold;
    position: relative;
`;
const Icon = styled.div`
    position: absolute;
    top: 50%;
    right: -16px;
    transform: translateY(-50%);
    color: ${props => props.Mode ? "#f900a1" : "#888"};
`;
const Dummy = styled.div`
    height: ${props => props.Height};
`;

const Scroll = styled.div`
    width: 100%;
    height: ${props => (props.Height)};
    overflow: hidden auto;
    margin-bottom: 10px;

    ::-webkit-scrollbar{
    　　width: 10px;
    }
    ::-webkit-scrollbar-track{
    　　background: #fff;
    }
    ::-webkit-scrollbar-thumb{
    　　background: #ccc;
    　　border-radius: 10px;
    　　box-shadow: inset 0 0 0 2px #fff;
    }
`;

const Panels = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    width: calc(100% - 20px);
    position: relative;
`;
const PanelWrap = styled.div`
    margin: 0;
    padding: 0;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
`;
const PileIcon = styled.div`
    position: absolute;
    bottom: -10px;
    left: ${props => props.Mode ? "0px" : "-5px"};
    font-size: 14px;
    opacity: ${props => props.Mode ? "1" : "0"};
    color: #f900a1;
    transition-duration: 0.2s;
    cursor: pointer;
    z-index: 1;
`;
